import AwardsCarousel from './awardsCarousel'

export default AwardsCarousel